const notificationRouter = [
    {
        path: "list-notification",
        name: "notification",
        component: () => import("@/views/admin/notification"),
        default: true,
        meta: {
            model: "notification",
            // requiresAuth: true,
        },
    },
    {
        path: "list-notification/add",
        name: "addNotification",
        component: () => import("@/views/admin/notification/function"),
        default: true,
        meta: {
            model: "notification",
            // requiresAuth: true,
        },
    },
    {
        path: "list-notification/edit/:id",
        name: "editNotification",
        component: () => import("@/views/admin/notification/function"),
        default: true,
        meta: {
            model: "notification",
            // requiresAuth: true,
        },
    },
];
export default notificationRouter;